<template>
<VueSelect
  v-model="valueAccessor"
  :multiple="true"
  :close-on-select="false"
  v-bind="selectFieldCommonVueSecectProps"
  class="multiple-select-feature-field"
>
  <!-- An attempt to make items bahave as checkboxes. VueSelect does not natively support deselecting items by clicking
  on a selected one. -->
  <!-- <template #option="option">
    <label class="custom-checkbox">
      <span class="custom-checkbox-label">{{ option.name }}</span>
      <input
        type="checkbox"
        class="hidden"
        :checked="value.includes(option.id)"
        @change.prevent
        @input.prevent
        disabled
      />
      <span class="checkbox"></span>
    </label>
  </template>
  <template #selected-option-container="">
    
  </template> -->
</VueSelect>
</template>

<script>
import AbstractFeatureField from './AbstractFeatureField'
import VueSelect from 'vue-select';
import selectFieldCommonVueSecectProps from './selectFieldCommonVueSecectProps'

export default AbstractFeatureField.extend({
  components: {
    VueSelect,
  },
  props: {
    value: Array,
  },
  computed: {
    selectFieldCommonVueSecectProps,
  },
})
</script>
